import { Link } from 'react-router-dom'
import PostMioLogo from '../components/PostMioLogo'

// ── i18n ───────────────────────────────────────────────────
const UI_TEXT = {
  IT: {
    badge: '7 giorni gratis — nessun addebito',
    h1: 'Inizia a usare PostMio™',
    sub: 'Prova gratis per 7 giorni. Poi solo €9,99/mese. Disdici quando vuoi.',
    features: [
      'Post per Instagram, Facebook e WhatsApp',
      'Risposte alle recensioni Google',
      '3 toni diversi a scelta',
      'Copia in un click — pronto in 10 secondi',
    ],
    cta: 'Inizia la prova gratuita →',
    trust: ['🔒 Pagamento sicuro', '✓ Disdici quando vuoi', '✓ 0€ per 7 giorni'],
    haveAccount: 'Hai già un account?',
    login: 'Accedi →',
  },
  EN: {
    badge: '7 days free — no charge',
    h1: 'Start using PostMio™',
    sub: 'Try free for 7 days. Then just €9.99/month. Cancel anytime.',
    features: [
      'Posts for Instagram, Facebook & WhatsApp',
      'Google review replies',
      '3 different tones to choose from',
      'Copy in one click — ready in 10 seconds',
    ],
    cta: 'Start free trial →',
    trust: ['🔒 Secure payment', '✓ Cancel anytime', '✓ €0 for 7 days'],
    haveAccount: 'Already have an account?',
    login: 'Log in →',
  },
  ES: {
    badge: '7 días gratis — sin cargo',
    h1: 'Empieza a usar PostMio™',
    sub: 'Prueba gratis durante 7 días. Luego solo €9,99/mes. Cancela cuando quieras.',
    features: [
      'Publicaciones para Instagram, Facebook y WhatsApp',
      'Respuestas a reseñas de Google',
      '3 tonos diferentes a elegir',
      'Copia en un clic — listo en 10 segundos',
    ],
    cta: 'Iniciar prueba gratuita →',
    trust: ['🔒 Pago seguro', '✓ Cancela cuando quieras', '✓ €0 durante 7 días'],
    haveAccount: '¿Ya tienes una cuenta?',
    login: 'Iniciar sesión →',
  },
  DE: {
    badge: '7 Tage kostenlos — keine Kosten',
    h1: 'PostMio™ jetzt nutzen',
    sub: '7 Tage kostenlos testen. Danach nur €9,99/Monat. Jederzeit kündbar.',
    features: [
      'Beiträge für Instagram, Facebook & WhatsApp',
      'Google-Bewertungsantworten',
      '3 verschiedene Töne zur Auswahl',
      'In einem Klick kopieren — in 10 Sekunden fertig',
    ],
    cta: 'Kostenlose Testversion starten →',
    trust: ['🔒 Sichere Zahlung', '✓ Jederzeit kündbar', '✓ €0 für 7 Tage'],
    haveAccount: 'Haben Sie bereits ein Konto?',
    login: 'Anmelden →',
  },
  FR: {
    badge: '7 jours gratuits — sans frais',
    h1: 'Commencer avec PostMio™',
    sub: 'Essayez gratuitement pendant 7 jours. Ensuite seulement €9,99/mois. Résiliez quand vous voulez.',
    features: [
      'Publications pour Instagram, Facebook et WhatsApp',
      'Réponses aux avis Google',
      '3 tons différents au choix',
      'Copier en un clic — prêt en 10 secondes',
    ],
    cta: 'Démarrer l\'essai gratuit →',
    trust: ['🔒 Paiement sécurisé', '✓ Résiliez quand vous voulez', '✓ €0 pendant 7 jours'],
    haveAccount: 'Vous avez déjà un compte ?',
    login: 'Se connecter →',
  },
  PL: {
    badge: '7 dni za darmo — bez opłat',
    h1: 'Zacznij korzystać z PostMio™',
    sub: 'Wypróbuj za darmo przez 7 dni. Potem tylko €9,99/miesiąc. Anuluj kiedy chcesz.',
    features: [
      'Posty na Instagram, Facebook i WhatsApp',
      'Odpowiedzi na recenzje Google',
      '3 różne tony do wyboru',
      'Kopiuj jednym kliknięciem — gotowe w 10 sekund',
    ],
    cta: 'Rozpocznij darmowy okres próbny →',
    trust: ['🔒 Bezpieczna płatność', '✓ Anuluj kiedy chcesz', '✓ 0€ przez 7 dni'],
    haveAccount: 'Masz już konto?',
    login: 'Zaloguj się →',
  },
}

function detectLang() {
  const lang = (navigator.language || '').toLowerCase()
  if (lang.startsWith('pl')) return 'PL'
  if (lang.startsWith('en')) return 'EN'
  if (lang.startsWith('es')) return 'ES'
  if (lang.startsWith('de')) return 'DE'
  if (lang.startsWith('fr')) return 'FR'
  return 'IT'
}

function renderTM(s) {
  if (typeof s !== 'string' || !s.includes('™')) return s
  const i = s.indexOf('™')
  return <>{s.slice(0, i)}<sup style={{fontSize:'0.5em',verticalAlign:'super',lineHeight:0}}>™</sup>{s.slice(i + 1)}</>
}

export default function Signup() {
  const t = UI_TEXT[detectLang()]

  const handleStart = () => {} // payments disabled

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lora:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #0A0A0A; }
        .signup-cta {
          width: 100%; background: #C9922A; color: #0A0A0A;
          padding: 15px; border-radius: 10px; font-size: 16px;
          font-weight: 700; cursor: pointer; border: none;
          font-family: 'DM Sans', sans-serif; letter-spacing: 0.2px;
          transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
        }
        .signup-cta:hover {
          background: #E5B050;
          transform: translateY(-1px);
          box-shadow: 0 6px 24px rgba(201,146,42,0.3);
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div style={{
        minHeight: '100vh', background: '#0A0A0A',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: 24, fontFamily: "'DM Sans', sans-serif",
      }}>
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none', marginBottom: 48 }}>
          <PostMioLogo size="lg" variant="dark" />
        </Link>

        {/* Card */}
        <div style={{
          width: '100%', maxWidth: 460,
          background: '#141414', border: '1px solid #2C2C2C',
          borderRadius: 16, padding: '40px 36px',
          boxShadow: '0 8px 48px rgba(0,0,0,0.5)',
          animation: 'fadeUp 0.3s ease-out',
        }}>
          {/* Badge */}
          <div style={{
            display: 'inline-block',
            background: 'rgba(201,146,42,0.12)', border: '1px solid #C9922A',
            borderRadius: 20, padding: '4px 14px',
            fontSize: 11, fontWeight: 600, color: '#C9922A',
            letterSpacing: 1.5, marginBottom: 20, textTransform: 'uppercase',
          }}>
            {t.badge}
          </div>

          <h1 style={{
            fontFamily: "'Lora', serif", fontSize: 28, fontWeight: 700,
            color: '#F0EDE8', marginBottom: 8, lineHeight: 1.2,
          }}>
            {renderTM(t.h1)}
          </h1>
          <p style={{ fontSize: 15, color: '#7A7A7A', marginBottom: 32, lineHeight: 1.65 }}>
            {t.sub}
          </p>

          {/* What's included */}
          <div style={{
            background: '#1A1A1A', border: '1px solid #2C2C2C',
            borderRadius: 10, padding: '18px 20px', marginBottom: 28,
          }}>
            {t.features.map(item => (
              <div key={item} style={{
                fontSize: 14, color: '#A0A0A0',
                padding: '6px 0', lineHeight: 1.5,
                display: 'flex', alignItems: 'center', gap: 4,
              }}>
                <span style={{ color: '#C9922A', marginRight: 2 }}>✓</span>
                {item}
              </div>
            ))}
          </div>

          <button className="signup-cta" onClick={handleStart} disabled style={{ cursor: 'default', opacity: 0.6, pointerEvents: 'none' }}>
            🚀 Coming Soon — Stay tuned for launch!
          </button>

          {/* Trust signals */}
          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap' }}>
            {t.trust.map(label => (
              <span key={label} style={{ fontSize: 11, color: '#555', fontWeight: 500 }}>{label}</span>
            ))}
          </div>
        </div>

        {/* Already have account */}
        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <span style={{ fontSize: 14, color: '#7A7A7A' }}>{t.haveAccount} </span>
          <Link to="/login" style={{ fontSize: 14, color: '#C9922A', fontWeight: 600, textDecoration: 'none' }}>
            {t.login}
          </Link>
        </div>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/privacy" style={{ fontSize: 12, color: '#555', textDecoration: 'none' }}>Privacy Policy</Link>
        </div>
      </div>
    </>
  )
}
